import React, { Fragment, FunctionComponent, useEffect, useMemo, useState } from 'react';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { Cell, Row, downloadSheets, generateSheet, listToObject } from '../../../utils';
import XLSX, { Range } from 'xlsx-js-style';
import { Button, Row as BSRow, Col, Table, DropdownButton, Dropdown, Form } from 'react-bootstrap';
import { AuthedLayout, EditableProperties, EditableTableDiv, HeaderDisplayKeysWithType } from '../../../components';
import { Class, TeeGradeClassStatistic } from '../../../model';
import { useSemGrade, useInspectionType } from '../../../hook';
import apis from '../../../apis';
import { ClassMapObj, Nullable } from '../../../types';
import { toast } from 'react-toastify';

type classTee = {
    className: string;
};
type classTeeSetting = Nullable<classTee> & EditableProperties;
const borderStyle = { color: { rgb: '000000' }, style: 'thin' } as const;
const fullBorderStyle = {
    top: borderStyle,
    bottom: borderStyle,
    left: borderStyle,
    right: borderStyle,
} as const;
const cellAlignStyle = {
    horizontal: 'center',
    vertical: 'center',
} as const;

const mapState = (state: ApplicationState) => ({ ...state.auth });
const mapDispatches = ErrorDispatches;

const connector = connect(mapState, mapDispatches);

type Props = ConnectedProps<typeof connector>;

const classheader: HeaderDisplayKeysWithType<classTeeSetting>[] = [
    { property: 'className', display: '班級' },
];

const teeImplTable: FunctionComponent<Props> = ({
    user,
    catchErrorForModal,
}) => {
    const { yearSem, element } = useSemGrade();
    const { inspectiontype, inspectionTypeDP } = useInspectionType({
        yearSem,
        catchErrorForModal,
    });
    const currentSem = user.semesters[user.currentSemester];
    // const [datas, setDatas] = useState<TeeGradeClassStatistic[]>([]);

    const [selectedIndex, setSelectedIndex] = useState<Set<number>>(
        new Set<number>()
    );
    const [TeeSettings, setTeeSettings] = useState<classTee[]>([]);
    const [classes, setClasses] = useState<ClassMapObj>({ '': '無年級資料' });
    const TeeSettingData = useMemo(refreshSettings, [
        selectedIndex, TeeSettings
    ]);
    const [showCustomHeader, setShowCustomHeader] =
        useState<boolean>(false);
    const [classList, setClassList] = useState([] as Class[]);
    const [title, setTitle] = useState<string>('');

    function refreshSettings() {
        return TeeSettings.map((s, i) => ({
            ...s,
            selected: selectedIndex.has(i),
        }));
    }

    useEffect(() => {
        apis
            .getClasses(currentSem.year, currentSem.sem)
            .then((classes) => {
                if (classes.length)
                    setClassList(classes);
                setClasses(
                    listToObject(
                        classes,
                        (c) => c.id,
                        (c) => c.name
                    )
                );

            })
            .catch(catchErrorForModal);
    }, [yearSem?.year, yearSem?.sem, inspectiontype]);

    useEffect(() => {
        if (classList.length) {
            const tableData = classList.map(x => ({
                className: x.name,
            }));
            setTeeSettings(tableData);
        }
    }, [classList]);
    console.log(classList)

    function generateTeeSheet() {
        const classObj = [...selectedIndex].map(index => classList[index]);
        toast
            .promise(
                apis.downloadTeeExcel(
                    user.schools[user.currentSchool].name,
                    classObj,
                    title,
                    currentSem.year,
                    currentSem.sem
                ), {
                pending: '下載中...',
                success: '下載成功！',
                error: '下載失敗！請查看錯誤資訊。',
            })
            .then((blob) => {
                const objlink = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = objlink;
                a.setAttribute('download', `潔牙紀錄表.xls`);
                document.body.appendChild(a);
                a.click();

                a.parentNode?.removeChild(a);
            })
            .catch(catchErrorForModal);
    }


    // const workSheet = generateSheet(content, { alignment: cellAlignStyle });
    return (
        <AuthedLayout>
            <BSRow className="justify-content-between">
                <Col>
                    <BSRow>
                        <Button
                            className='mt-2'
                            disabled={!selectedIndex.size}
                            onClick={generateTeeSheet}
                        >
                            產生記錄表
                        </Button>
                    </BSRow>
                </Col>
            </BSRow>
            <hr />
            <BSRow>
                <Col>
                    <Form.Group controlId="formCustomHeader">
                        <BSRow className="align-items-center">
                            <Col xs="auto">
                                <Form.Check
                                    type="checkbox"
                                    label="自訂表頭名稱"
                                    onChange={(e) => setShowCustomHeader(e.target.checked)}
                                />
                            </Col>
                            <Col>
                                {showCustomHeader && (
                                    <Form.Control
                                        type="text"
                                        placeholder="輸入自訂表頭名稱"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                )}
                            </Col>
                        </BSRow>
                    </Form.Group>
                </Col>
            </BSRow>
            <BSRow>
                <EditableTableDiv
                    headers={classheader}
                    values={TeeSettingData}
                    onSelected={(s) => {
                        setSelectedIndex((last) => {
                            if (s.index !== undefined) {
                                if (s.checked) last.add(s.index);
                                else last.delete(s.index);
                                return new Set(last);
                            } else {
                                if (s.checked) return new Set(TeeSettings.keys());
                                else return new Set();
                            }
                        });
                    }}
                />
            </BSRow>
        </AuthedLayout>
    );
};



export const TeeImplTable = connector(teeImplTable);
